import './App.css';
/*import './pages/assets/plugins/owl.carousel/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';*/
import './pages/assets/dist/css/bootstrap.min.css';
import './pages/assets/css/style.css';
import './pages/assets/css/shortcodes.css';
import './pages/assets/css/font-awesome.min.css';
import { HashRouter as Router, Route, } from 'react-router-dom';
import React from 'react';
import { getLiquidaciones, getAlfresco, getApiUrl } from "./config/envConfig";
import PagLiquidaciones from './components/pagLiquidaciones';
import PagNoticias from './components/pagNoticias';
import PagEmisores from './components/pagEmisores';
import Home from './components/home';


export default class App extends React.Component {

  constructor() {
    super();
    this.state = {
      noticia: null,
      liquidacion: null,
      loadingLiq: true,
      loadingNot: true,
      popup: true
    }

    this.styleLink = document.createElement('link');
    this.styleLink.rel = 'stylesheet';
    this.styleLink.type = 'text/css';

    this.styleLink.href = getApiUrl + 'https://www.farmalink.com.ar/api/msEstaticos/css/skinFARMA.css';
  }

  // componentDidMount() {
  //   document.head.appendChild(this.styleLink);
  // }

  componentWillUnmount() {
    // Limpiar el event listener del scroll
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  async componentDidMount() {
    document.getElementById("about").style.display = 'none';
    const urlLiquidaciones = getLiquidaciones()+'/getLiquidaciones';
    const urlAlfresco =  getAlfresco()+'/getNoticiasAlfresco';
    //const urlContent = getContent()+'/getNoticiasContent';

    // Ajustar posición del botón de WhatsApp según visibilidad del back-top
    this.handleScroll = () => {
      const backTop = document.getElementById('back-top');
      const whatsappButton = document.getElementById('whatsappButton');

      if (backTop && whatsappButton) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollBottom = document.documentElement.scrollHeight - window.innerHeight - scrollTop;

        // Verificar si back-top está visible (scroll > 100)
        if (scrollTop > 100) {
          // Back-top está visible, subir WhatsApp
          whatsappButton.classList.add('back-top-visible');

          // Verificar si back-top tiene la clase move-up (cerca del final de la página)
          if (scrollBottom < 50) {
            whatsappButton.classList.add('back-top-moved');
          } else {
            whatsappButton.classList.remove('back-top-moved');
          }
        } else {
          // Back-top no está visible, bajar WhatsApp
          whatsappButton.classList.remove('back-top-visible');
          whatsappButton.classList.remove('back-top-moved');
        }
      }
    };

    window.addEventListener('scroll', this.handleScroll);
    // Ejecutar una vez al cargar para establecer el estado inicial
    setTimeout(this.handleScroll, 100);
    await Promise.all([
      fetch(urlLiquidaciones, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }),
      fetch(urlAlfresco, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
      })
    ]).then(([liquidaciones, noticias]) => {
      let liq;
      let not;

      liquidaciones.json().then(data1 => {
        if (data1 && data1.estado && data1.estado.codigo === "0") {
          liq = data1.liquidaciones;
          this.setState({
            liquidacion: liq,
            loadingLiq: false
          });
        } else {
          console.log("sin datos de liquidaciones")
          this.setState({
            loadingLiq: false
          })
        }
      }).catch((err) => {
        console.log("error de liquidaciones", err)
        this.setState({
          loadingLiq: false
        })
      })

      noticias.json().then(data2 => {
        if (data2 && data2.estado && data2.estado.codigo === "0") {
          not = data2.alfrescoList;
          this.setState({
            noticia: not,
            loadingNot: false
          });
        } else {
          console.log("sin datos en noticias")
          this.setState({
            loadingNot: false
          })
        }
      }).catch((err) => {
        console.log("error de noticias", err)
        this.setState({
          loadingNot: false
        })
      })

    }).catch((err) => {
      console.log(err)
      this.setState({
        loadingLiq: false,
        loadingNot: false
      })
    })
  }

  render() {
    return (
      <Router>
        {this.state.loadingLiq || this.state.loadingNot ? <div id="preloader">
          <div id="logo" />
          <div id="loading" />
        </div> : null
        }
        <div>
          <Route exact path="/"><Home /></Route>
          <Route path="/home/#/"><Home /></Route>
          <Route path="/liquidaciones"> <PagLiquidaciones key={this.state.liquidacion} liquidacion={this.state.liquidacion} /></Route>
          <Route path="/noticias"><PagNoticias key={this.state.noticia} noticia={this.state.noticia} /></Route>
          <Route path="/emisoresRecetaElectronica"><PagEmisores /></Route>
        </div>
        <div id="back-top">
            <a class="rounded" href="#top">
                <i class="fa fa-angle-up"></i>
            </a>
        </div>
        <div id="whatsappButton">
          <a href="http://api.whatsapp.com/send/?phone=541135789570" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
          </a>
        </div>
      </Router>

    )
  }
}

/*basename={process.env.PUBLIC_URL}*/